/* eslint-disable */
import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { styled } from '@mui/styles';

import './styles.css';

import { colors } from '../../helpers';
import { useTranslate } from '../../hooks';
import { Loader } from '../icons/Loader';

const CustomAutocomplete = styled(Autocomplete)({
  '& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input': {
    font: 'normal normal normal 14px/24px;',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: colors.lightgrey,
  },
  '& .MuiInputBase-input': {
    font: 'normal normal bold 0.85em',
    color: colors.primary,
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: colors.primary,
  },
  '& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root': {
    fontSize: '0.85em',
  },
  '& label.Mui-focused': {
    color: colors.primary,
  },
  '& .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input': {
    fontSize: '0.85em',
  },
});

type OptionValue = {
  label?: string;
  id?: number | string;
};

type Props = {
  data?: OptionValue[];
  onChange?: (newValue: string, _: any) => void;
  value?: OptionValue;
  label?: string;
  showError?: boolean;
  errorText?: string;
  multiple?: boolean;
  defaultValue?: OptionValue;
  className?: string;
  isLoading?: boolean;
  disabled?: boolean;
  clearable?: boolean;
  inputProps?: any;
  containerClassName?: string;
  autoCompleteProps?: any;
};

export function AutoComplete({
  data = [],
  onChange,
  value,
  label,
  showError,
  errorText,
  multiple = false,
  defaultValue,
  className = '',
  isLoading = false,
  disabled = false,
  clearable = true,
  inputProps = {},
  containerClassName,
  autoCompleteProps,
}: Props) {
  const { dir, translate } = useTranslate();

  return (
    <div className={`auto-complete-container ${containerClassName}`}>
      <CustomAutocomplete
        size="medium"
        multiple={multiple}
        disablePortal
        disabled={disabled}
        id="combo-box"
        isOptionEqualToValue={(option: OptionValue, value: OptionValue) =>
          option.id === value.id
        }
        options={data}
        onChange={(_, newValue: string) => {
          onChange?.(newValue, _);
        }}
        disableClearable={!clearable}
        noOptionsText={translate('no-options')}
        defaultValue={defaultValue}
        filterSelectedOptions
        className={className}
        getOptionLabel={(option: OptionValue) => option.label}
        value={value}
        renderInput={(params) => (
          <TextField
            {...params}
            dir={dir}
            label={label}
            error={showError}
            className={className}
            helperText={errorText}
            {...inputProps}
          />
        )}
        {...autoCompleteProps}
      />
      <div className="auto-complete-container-loader">
        {isLoading && <Loader width={15} />}
      </div>
    </div>
  );
}
